import {Observable} from 'rxjs';

export abstract class RecaptchaAdapters {
  abstract validateRecaptcha(token: string): Observable<any>;
}
